import { useEffect, useState } from 'react';
import SerieTableSelect from '../../Serie/SerieTableSelect';
import SerieProfile from '../../Serie/SerieProfile';
import { Container, Grid, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import DiaLetivoExtraSerieTable from './DiaLetivoExtraSerieTable';
import { deleteById, save, findByAnoLetivoAndSerieCodSerie } from './api-dia-letivo-extra-serie';
import { errorMessage } from '../../../util/ConfirmAlertUtil';
import { confirmAlert } from 'react-confirm-alert';
import DiaLetivoExtraSerieTableAdding from './DiaLetivoExtraSerieTableAdding';


const useStyles = makeStyles({
    container: {
        flexGrow: '1',
        margin: '20px',
        padding: '10px'

    }
})

const DiaLetivoExtraSerieContainer = () => {
    const [serie, setSerie] = useState(null);
    const classes = useStyles();
    const [listDiaLetivoExtraSerie, setListDiaLetivoExtraSerie] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isAdding, setIsAdding] = useState(false);
    const [isLoadingAction, setIsLoadingAction] = useState(false);

    useEffect(() => {
        if (serie && serie.codSerie) {
            setIsLoading(true);
            findByAnoLetivoAndSerieCodSerie(serie.codSerie).then((data) => {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setListDiaLetivoExtraSerie(data);
                }
                setIsLoading(false);
            })
        }

    }, [serie]);

    const handleRemove = (codDiaNaoLetivoSerie) => {
        confirmAlert({
            title: 'Alerta',
            message: 'Deseja deletar este registro?',
            buttons: [
                {
                    label: 'Sim',
                    onClick: () => {
                        setIsLoadingAction(true);
                        deleteById(codDiaNaoLetivoSerie).then((data) => {
                            if (data.error) {
                                errorMessage(data.message);
                            } else {
                                setListDiaLetivoExtraSerie((prevState) => prevState.filter((ps) => ps.codigo !== codDiaNaoLetivoSerie));
                            }
                        })
                        setIsLoadingAction(false);
                    }
                },
                {
                    label: 'Não',
                    onClick: () => { }
                }
            ]
        });


    }

    const handleSave = async (listDiaLetivoExtraSerieSelect) => {
        setIsLoadingAction(true);
        await listDiaLetivoExtraSerieSelect.forEach((dles) => {
            const dnlSerie = {
                diaLetivoExtra: dles,
                serie: serie
            }
            save(dnlSerie).then((data) => {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setListDiaLetivoExtraSerie((prevState) => ([
                        ...prevState,
                        data
                    ]));
                }
            })
        })
        setIsAdding(false);
        setIsLoadingAction(false);
    }

    return (
        <Container maxWidth='lg'>
            <Grid
                container
                component={Paper}
                justifyContent='center'
                spacing={3}
                className={classes.container}
            >
                {serie ?
                    <Grid container component={Paper}>
                        <SerieProfile
                            serie={serie}
                            setSerie={setSerie}
                        />
                        {isAdding ?
                            <>
                                <DiaLetivoExtraSerieTableAdding
                                    serie={serie}
                                    handleSave={handleSave}
                                    isLoadingAction={isLoadingAction}
                                    setIsAdding={setIsAdding}
                                />
                            </> :
                            <DiaLetivoExtraSerieTable
                                listDiaLetivoExtraSerie={listDiaLetivoExtraSerie}
                                isLoading={isLoading}
                                setIsAdding={setIsAdding}
                                handleRemove={handleRemove}
                                isLoadingAction={isLoadingAction}
                            />
                        }


                    </Grid> :
                    <SerieTableSelect setSerie={setSerie} />
                }

            </Grid>
        </Container>
    )
}

export default DiaLetivoExtraSerieContainer;